module.exports = __webpack_public_path__ + "static/media/14.fa60738d.jpg";